import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import { cText } from '../creator/cGameObjects/cText';
import {cScene} from '../creator/cScene'
import { maxCoins } from '../creator/cDisplayObjects/EvaluationCard'



export class clockDisplay extends cDisplay {

  private minutes: number 
  private hours: number 
  
  private pIdx: number


  private tg
  private p1: Phaser.GameObjects.Sprite
  private p2: Phaser.GameObjects.Sprite
  private p3: Phaser.GameObjects.Sprite

  init(){
    super.init()
    console.log('Clock Display');
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
    })

    this.hours = 10
    this.minutes = 23
    this.pIdx = 1;
  }

  rndX(){
    var si = 100
    return Math.round( Math.random() * si ) - (si/2)
  }


  nextPerson(){
    if (this.p3){
      this.tg.remove(this.p3);
      this.p3.destroy()
    }
    this.p3 = this.p2
    this.p2 = this.p1

    this.p1 = new Phaser.GameObjects.Sprite(this.scene,0,0,'watch_people','person_' + this.pIdx);
    this.p1.setDepth(1)
    this.tg.add(this.p1);

    this.pIdx ++
    if (this.pIdx === 9) this.pIdx = 1

    this.p1.setPosition( 518 +  this.rndX(),629 )

    if (this.p2){
      this.p2.setPosition( 1113+  this.rndX(),593 )
      this.p2.setDepth(2)
      this.p2.setScale(0.9)
    }

    if (this.p3){
      this.p3.setPosition( 1388+  this.rndX(),642 )
      this.p1.setDepth(3)
      this.p3.setScale(-0.9,0.9)      
    }

    this.tg.sort('depth')

  }


  buildScene(){    
    super.buildScene();

    this.tg = this.getByName('person_holder')

    var long = this.getByName('arm_long')
    var short = this.getByName('arm_short')
    var $this = this
    var cc: number = 0
    var tt = this.scene.time.addEvent({
      delay: 33,
      loop: true,
      callback:()=>{
        cc++
        console.log(cc)
        if (cc % 20 === 0){
          console.log('NEXT')
          this.nextPerson()
        }

        this.minutes += 2
        if (this.minutes > 59){
          this.minutes = 0
          this.hours++
        }

        if (this.hours == 17 && this.minutes > 57){
          this.hours = 18
          this.minutes = 0
          tt.paused = true;

          this.tg.removeAll(true);
          this.getByName('arm_short').visible = false;
          this.getByName('arm_long').visible = false;
          (this.scene as cScene).triggerSceneEvent('done')
          
        }

        long.angle = 360/60*this.minutes
        short.angle = 360/12*(this.hours + (this.minutes/60));        
      },
    })



  }

  update(){
    console.log('lk')
  }

}

